interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  center?: boolean;
  linkTo?: string;
  linkText?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  center = false,
  linkTo,
  linkText = '查看全部',
}: SectionHeadingProps) {
  return (
    <div
      className={`mb-6 flex w-full flex-col gap-3 sm:mb-8 ${
        center ? 'items-center text-center' : ''
      }`}
    >
      <div className="flex w-full flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div className={`flex flex-col ${center ? 'items-center' : ''} gap-2`}>
          {eyebrow && (
            <span className="inline-flex w-fit items-center gap-1.5 text-xs font-semibold tracking-wider text-primary-600 uppercase">
              <i className="ri-record-circle-fill text-[8px]"></i>
              {eyebrow}
            </span>
          )}
          <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            {title}
          </h2>
          {desc && (
            <p className="max-w-2xl text-sm leading-6 text-foreground-600 md:text-base">
              {desc}
            </p>
          )}
        </div>
        {linkTo && (
          <a
            href={linkTo}
            className="inline-flex w-fit shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-800"
          >
            {linkText}
            <i className="ri-arrow-right-line"></i>
          </a>
        )}
      </div>
    </div>
  );
}